import React from "react";
import Select from "react-select";
import { colors } from "../../../css components/Style";

export default function Categorize({ categorize, setCategorize, setPage }) {
  const options = [
    { value: "Brands", label: "Brands", color: colors.blue },
    {
      value: "Campaign Offers",
      label: "Campaign Offers",
      color: colors.green,
    },
    {
      value: "Unverified Campaigns",
      label: "Unverified Campaigns",
      color: colors.yellow,
    },
    {
      value: "Rejected Campaigns",
      label: "Rejected Campaigns",
      color: colors.error,
    },
  ];

  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      height: "50px",
      p: "15px 18px",
      color: "#000000",
      fontWeight: 400,
      display: "flex",
      width: "inherit",
      fontsize: "14px",
      lineHeight: "20px",
      alignItems: "center",
      borderRadius: "30px",
      justifyContent: "space-between",
      boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: " #000000",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      fontSize: "18px",
      fontWeight: 600,
      color: data.color,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        color: data.color,
        fontWeight: isSelected ? 600 : 400,
        backgroundColor: "white",
        fontSize: "18px",
        lineHeight: "20px",
        mixBlendMode: "normal",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };

  const handleTypeSelect = (e) => {
    setCategorize(e.value);
    setPage(1);
  };

  return (
    <Select
      styles={style}
      options={options}
      onChange={handleTypeSelect}
      isSearchable={false}
      components={{
        IndicatorSeparator: () => null,
      }}
      value={options.filter(function (option) {
        return option.value === categorize;
      })}
    />
  );
}
